class BuyButtons extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.els.cartAdd.element, 'click', this.addToCart.bind(this))
    this.observeSubscriptionWidgetLoading()
  }

  // Observe the subscription widget for when it starts adding to cart, then observe for when it finishes loading to open the cart drawer
  observeSubscriptionWidgetLoading () {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target
          if (target.classList.contains('gbbMixCascadeAddToCartBtn--loading')) {
            window.drawers.activeDrawerKey = 'cart'
            this.startSubscriptionAddLoading()
            this.observeSubscriptionWidgetLoadingFinished()
            observer.disconnect()
          }
        }
      })
    })

    observer.observe(this, { attributes: true, subtree: true })
  }

  // Observe the subscription widget for when it finishes adding to cart, then refresh the cart (which also clears the loading state) and start observing for when it starts loading again
  observeSubscriptionWidgetLoadingFinished () {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target
          if (!target.classList.contains('gbbMixCascadeAddToCartBtn--loading')) {
            this.stopSubscriptionAddLoading()
            observer.disconnect()
            this.observeSubscriptionWidgetLoading()
          }
        }
      })
    })

    observer.observe(this, { attributes: true, subtree: true })
  }

  addToCart (e) {
    e.preventDefault()

    const button = e.target
    if (!button) return

    const form = button.closest('form')
    if (!form) return

    this.addToCartFromForm(form)
  }

  async addToCartFromForm (form) {
    return window.BAO.Cart.addItemFromForm(form)
  }

  // Opening the drawer triggers a cart refresh whose CHANGED/AFTER_ADD events clear the push
  // cart's loading state, so keep re-asserting it until the widget's add request has finished
  startSubscriptionAddLoading () {
    this.assertPushCartLoading =
      this.assertPushCartLoading ??
      (() => {
        if (this.pushCart) this.pushCart.loading = true
      })

    this.assertPushCartLoading()

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.assertPushCartLoading,
    )
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.AFTER_ADD,
      this.assertPushCartLoading,
    )

    // Failsafe: if we never see the widget finish (e.g. its request hangs, or it replaces the
    // button node so the class removal never mutates), release the loading state regardless
    this.subscriptionLoadingTimeout = setTimeout(
      () => this.stopSubscriptionAddLoading(),
      5000,
    )
  }

  stopSubscriptionAddLoading () {
    clearTimeout(this.subscriptionLoadingTimeout)

    window.BAO.eventBus.removeEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.assertPushCartLoading,
    )
    window.BAO.eventBus.removeEventListener(
      window.BAO.EVENTS.PUSH_CART.AFTER_ADD,
      this.assertPushCartLoading,
    )

    window.drawers.updateCart()
  }

  get pushCart () {
    return document.querySelector('push-cart')
  }
}

if (!customElements.get('buy-buttons')) {
  customElements.define('buy-buttons', BuyButtons)
}
